import { $authHost } from ".."
import { getStartParamsQuery } from "../../helpers/api/apiHelper"

// Тут випадково дублював файл. Вірний знаходитсья в папці "pack". Це теж працююче, але не додавати сюди

export const getSupplierTypesAPI = async () => {
    const {data} = await $authHost.get(`api/suppliers/types`)
    return data
}

export const addSupplierAPI = async (supplier) => {
    const {data} = await $authHost.post(`api/suppliers/`, supplier)
    return data
}

export const editSupplierAPI = async (supplier) => {
    const {data} = await $authHost.post(`api/suppliers/${supplier.id}`, supplier)
    return data
}

export const getSupplierAPI = async ({ supplierId }) => {
    const {data} = await $authHost.get(`api/suppliers/${supplierId}`)
    return data
}

export const getSuppliersAPI = async ({ offset, limit, query }) => {

    // let params = ''
    // if (query) {
    //     params = `?query=${query}`
    // } else if ((offset || offset === 0) && limit) {
    //     params = `?offset=${offset}&limit=${limit}`
    // }

    let params = ''
    if (query) {
        params = `${getStartParamsQuery({ params })}query=${query}`
    }
    
    if ((offset || offset === 0) && limit) {
        params += `${getStartParamsQuery({ params })}offset=${offset}&limit=${limit}`
    }

    const {data} = await $authHost.get(`api/suppliers/${params}`)
    return data
}

export const agreeSupplierLawyerAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/suppliers/agree_lawyer/${dataForBd.id}`, dataForBd)
    return data
}

export const agreeSupplierSecurityAPI = async (dataForBd) => {
    const {data} = await $authHost.post(`api/suppliers/agree_security/${dataForBd.id}`, dataForBd)
    return data
}
